import * as Validation from "../../common/utils/Validation";
import {addBillingOrg, createPortalUser, editBillingOrg} from "../../billing/organizations/actions/BillingOrganizationsActions";
import {addEditBillingOrgActionTypes} from "../../billing/organizations/constants/BillingOrganizationsActionConstants";

/**
 * This is the Middleware to validate the object generated by the add/edit DP modal and the enable CP User Modal
 * @param store, action
 * @returns Makes the call to custom validation procedure and conditionally dispatches
 * the check-update action or the post action
 */
const validateBillingOrgFormMiddleware = (store) => (next) => (action) => {

    switch (action.type) {

        case addEditBillingOrgActionTypes.VALIDATE_BILLING_ORG_FORM: {
            next(action);

            const { billingOrgObject } = action.payload;

            // because the field on the form defaults to a empty string value if user clears the input
            // this is to set it back to 0 and get the correct type in.
            billingOrgObject.orgBilling.monthly_minimum_commitment =
                billingOrgObject.orgBilling.monthly_minimum_commitment === ""
                    ? 0.00
                    : parseFloat(billingOrgObject.orgBilling.monthly_minimum_commitment);
            billingOrgObject.orgBilling.monthly_platform_fee =
                billingOrgObject.orgBilling.monthly_platform_fee === ""
                    ? 0.00
                    : parseFloat(billingOrgObject.orgBilling.monthly_platform_fee);

            // Call the custom validation for the fields.
            // else/invalid inputs are handled by Validation.js which sends out a
            // form error/warning message through redux.
            if (Validation.validateBillingOrganizationForm(billingOrgObject)) {
                // check if the redux action dispatched is for editing the data provider
                if (billingOrgObject.orgDetail.id) {
                    const orgID = billingOrgObject.orgDetail.id;
                    store.dispatch(editBillingOrg(billingOrgObject, orgID))
                } else {
                    store.dispatch(addBillingOrg(billingOrgObject))
                }
            }

            break;
        }

        case addEditBillingOrgActionTypes.VALIDATE_CP_USER:
            next(action);

            const {portalPayload} = action.payload;

            if (Validation.validateNewCPUser(portalPayload)) {
              store.dispatch(createPortalUser(portalPayload))
            }


            break;

        default: next(action)
    }
}

export default validateBillingOrgFormMiddleware;
